import { useLDFlag } from 'src/contexts/LaunchDarklyContext/LaunchDarklyContext';

/**
 * LaunchDarkly flag backing the "phone number as a required field" experiment.
 *
 * @see https://app.launchdarkly.com/projects/web-dev/flags/01-phone-number
 * @see [redacted]##############################
 */
export const PHONE_REQUIRED_FLAG = '01-phone-number';

/**
 * Any other value -- including the `off` default and a missing `ld_flags`
 * cookie -- is the control arm, which is the site's existing behaviour.
 */
const TREATMENT_VALUE = 'variant';

export const isPhoneRequiredTreatment = (flag: unknown): boolean => {
  return flag === TREATMENT_VALUE;
};

/**
 * True when the visitor is in the treatment arm. Calling this hook fires
 * VIEWED_EXPERIMENT, so only mount it after `isUsOrganicFormTraffic()` is true.
 */
export const usePhoneRequiredVariant = (): boolean => {
  const flag = useLDFlag(PHONE_REQUIRED_FLAG);

  return isPhoneRequiredTreatment(flag);
};
